/*
 * @Author: Chao Yang
 * @Date: 2020-05-06 10:42:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-02-25 12:16:56
 */

import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  EventEmitter,
  Output,
  ComponentFactoryResolver,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { CONFIG_DATA } from './common/ad-dialog-config-inject-key';
import { AdDialogConfig } from './ad-dialog-config';
import { getComponentMeta } from '../utils/get-component-meta';
import { intersectArrayList } from '../utils/intersect-array-list';

@Component({
  selector: 'ad-dialog',
  templateUrl: './ad-dialog.component.html',
  styleUrls: ['./ad-dialog.component.scss'],
})
export class AdDialogComponent implements OnInit, OnDestroy {
  constructor(@Inject(CONFIG_DATA) private context: any, private componentFactoryResolver: ComponentFactoryResolver) { }
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @ViewChild("host", { static: true, read: ViewContainerRef }) hostContainer: ViewContainerRef;
  showHeader: boolean = true;
  config: AdDialogConfig;
  templateRefContext: any;
  ngOnInit() {
    this.config = this.context.config as AdDialogConfig;
    if (this.config.showHeader != undefined) {
      this.showHeader = this.config.showHeader;
    }
    this.templateRefContext = this.config.data;
    if (!this.config.templateRef && this.config.embededComponent) {
      setTimeout(() => {
        this.renderComponent();
      }, 0)
    }
  }

  renderComponent() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.config.embededComponent);
    const componentRef = this.hostContainer.createComponent(componentFactory);
    let config = this.context.config as AdDialogConfig;
    if (config && config.autoBindProperty && config.data && typeof config.data === "object") {
      let names = getComponentMeta(componentRef.componentType).inputs;

      let instance = componentRef.instance;
      let configNames = Object.getOwnPropertyNames(config.data);
      let keys = intersectArrayList([names, configNames]);
      keys = configNames;
      keys.forEach(key => {
        instance[key] = config.data[key];
      })
    }
  }

  closeDialog() {
    if (this.config.disableCloseEvent === true) {
      return;
    }
    this.context.close(this.context.overlayRef);
    this.onClose.emit();
  }

  ngOnDestroy(): void {
    this.context = null;
    this.config = null;
  }
}
